import conferenceFallback from "../../assets/media/background/conference2 Large.jpeg";
import gwsceBg from "../../assets/media/background/gwsce-bg.jpeg";
import idassBg from "../../assets/media/background/idass.jpg";
import home2 from "../../assets/media/background/home2 Large.jpeg";

const SLUG_IMAGE_MAP: Record<string, string> = {
  "ieee-swc-2023": conferenceFallback,
  "idass-2024": idassBg,
  "idass-2025": idassBg,
  "gwsce-2025": gwsceBg,
  "ieee-dtpi-2026": home2,
};

export function getEventImage(
  slug: string | undefined | null,
  coverImageUrl: string | null | undefined,
): string {
  if (coverImageUrl) return coverImageUrl;
  if (slug && SLUG_IMAGE_MAP[slug]) return SLUG_IMAGE_MAP[slug];
  return conferenceFallback;
}
